@use '@/scss/underscore' as _;

.switchFactorLink {
  margin-top: _.unit(6);
}
